import * as React from 'react';
import GetAttributeQuery from '../../../../components/Query/Attributes/Attribute';
import { extractAttributesFromProducts } from '../../../../helpers/attributes/extractAttributesFromProducts';
import VariantSelector, { IVariantSelectorOption } from './VariantSelector';
import { findVariantsWithDefinition } from '../../../../helpers/variants/findVariantWithDefinition';

interface IVariantSelectorFormProps {
  name: string;
  className?: string;
  variant: GQL.IProductVariant;
  onChange: (variant: GQL.IProductVariant) => void;
}

class VariantSelectorForm extends React.Component<IVariantSelectorFormProps> {

  private variants: Array<GQL.IProductVariant> = [];

  public render() {
    const { variant } = this.props;

    this.variants = (variant && variant.product && variant.product.variants 
      ? variant.product.variants
      : [] as any);

    const attribs = extractAttributesFromProducts([ variant.product ]);
  
    // produkt má varianty a attributy
    if (this.variants && this.variants.length > 0 && attribs && Object.keys(attribs).length > 0) {
      // první atribut
      const attributeId = Object.keys(attribs)[0];
      const attributeValueIds = Object.keys(attribs[attributeId]);

      // podle hodnot atributu vygeneruju pole s variantami a hodnotymi atributu
      return (
        <React.Fragment>
            <GetAttributeQuery
              id={attributeId}
            >
              {({ attribute }: any) => {
                if (attribute && attribute.attribute) {
                  // seznam hodnot atributů pro výběr varianty
                  const values: Array<IVariantSelectorOption> = [];
                  attribute.attribute.values
                    .filter((value: any) => {
                      if (attributeValueIds && attributeValueIds.indexOf(value.id) >= 0) {
                        const variantsWithDefinition = findVariantsWithDefinition(this.variants, attribute.attribute, value);
                        if (variantsWithDefinition.length > 0) {
                          values.push({
                            variant: variantsWithDefinition[0],
                            value: {...value}
                          });
                        }
                      }
                    });

                  return (
                    <VariantSelector
                      name={this.props.name}
                      className={this.props.className}
                      value={variant.id}
                      options={values}
                      attribute={attribute}
                      variant={variant}
                      onChange={this.props.onChange}
                    />
                  );
                }

                return null;
              }}
            </GetAttributeQuery>
        </React.Fragment>
      );
    }

    return null;
  }
}

export default VariantSelectorForm;


// WEBPACK FOOTER //
// ./src/components/ProductDetail/components/VariantSelector/index.tsx